import AppHeader from 'components/AppHeader/AppHeader';
import MainNav from 'components/MainNav/MainNav';
import { useBreakpoints } from 'providers/Breakpoints';
import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import './Layout.scss';

export default function Layout({ isLoading = false }: { isLoading?: boolean }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const breakpoints = useBreakpoints();

    useEffect(() => {
        if (!breakpoints.isSmallDown) {
            setIsMenuOpen(false);
        }
    }, [breakpoints.isSmallDown]);

    return (
        <>
            {/* Side nav bar */}
            <MainNav
                isLoading={isLoading}
                isMenuOpen={isMenuOpen}
                closeMenu={() => setIsMenuOpen(false)}
            />

            <div className="Layout__Container">
                {!isLoading && <AppHeader onMenuClick={() => setIsMenuOpen(!isMenuOpen)} />}
                <main className="Layout__Main">{!isLoading && <Outlet />}</main>
            </div>
        </>
    );
}
